import script from "./Tags.vue?vue&type=script&lang=ts&setup=true"
export * from "./Tags.vue?vue&type=script&lang=ts&setup=true"

import "./Tags.vue?vue&type=style&index=0&id=241c517b&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-241c517b"]])

export default __exports__